export default __webpack_public_path__ + "static/media/litho-demo-web-agency.f9ec6139.jpg";